export enum HumidityMapIcons {
  'map-pin-component-available',
  'map-pin-component-humidity',
}

export enum HumidityPopuptitleIcons {
  '/assets/images/icon-status-ok.svg',
  '/assets/icons/icon-40-activity-log-humidity.svg',
}
